'use client';

import { Box, CircularProgress, Stack } from '@mui/material';
import Image from 'next/image';
import React from 'react';

const Loading = () => {
  return (
    <Stack
      suppressHydrationWarning
      width={'100vw'}
      height={'100vh'}
      bgcolor={'white'}
      alignItems={'center'}
      justifyContent={'center'}>
      <Box position={'relative'}>
        <Stack
          top={'50%'}
          left={'50%'}
          position={'absolute'}
          alignItems={'center'}
          justifyContent={'center'}
          sx={{ transform: 'translate(-50%, -50%)' }}>
          <CircularProgress size={60} sx={{ color: 'black' }} />
        </Stack>
        <Image
          priority
          width={48}
          height={48}
          alt='lfg-logo'
          src={'/logo.png'}
          className={'rounded-full bg-gray-400'}
          style={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)' }}
        />
      </Box>
    </Stack>
  );
};

export default Loading;
